import React from "react";
import Uri from "jsuri";
import { Bar, BarChart, Tooltip } from "recharts";
import Heading from "components/Elements/Heading";
import { Metric, CustomMetricToolTip, Error } from "components/Utils/Utils";
import SummaryChannelByType from "components/Summary/SummaryChannelByType";

const SummaryChannel = (props) => {
  const { data, url } = props;

  if (data.hasData === false) {
    return <Error minHeight={360} />;
  }

  const name = new Uri(url).getQueryParamValue("metric").replace("_", " ");

  return (
    <>
      <div className="d-flex">
        <div>
          <Heading size={5} className="mb-6">
            <span className="font-weight-bold mr-1 text-capitalize">
              {name}
            </span>
            Last Week
          </Heading>
          <div className="d-flex">
            <Metric {...data.currentValue} size={"lg"} />
          </div>
        </div>

        <div className="mt-3 pl-3 pr-3">
          <Heading size={6} className="mb-3">
            vs. Week Prior
          </Heading>
          <Metric {...data.pastValue} size="sm" />
        </div>

        <div className="mt-3 pl-3">
          <Heading size={6} className="mb-2">
            Last 12 Weeks
          </Heading>

          <BarChart height={30} width={120} barGap={2} data={data.last12Weeks}>
            <Bar
              dataKey="value"
              fill="#B2C2C9"
              dot={false}
              barSize={8}
              isAnimationActive={false}
            />
            <Tooltip content={<CustomMetricToolTip />} />
          </BarChart>
        </div>
      </div>

      <SummaryChannelByType data={data.table} graph={data.graph} />
    </>
  );
};

export default SummaryChannel;
